import { MarketplaceGetUserPermissionsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useMarketplaceUserPermissions = () => {
  const { data, loading } = useQuery(MarketplaceGetUserPermissionsDocument)

  return {
    loading,
    canInstallCompanyWideIntegration:
      data?.marketplace._policies.installationInstallCompanyWideIntegration.can,
  }
}
